import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { BaseError } from '@utils/types/shared/base';
import { AdminTranslationSettingsResponse } from '@utils/types/admin';

export const ADMIN_TRANSLATION_QUERY_KEY = 'adminTranslationSettings';

/**
 * Hook to fetch translation settings configuration
 *
 * GET /api/admin/settings/translation
 *
 * Returns current translation config (DeepL settings with masked API key)
 */
export const useGetAdminTranslation = () => {
  const fetchTranslation = async () => {
    const url = `api/admin/settings/translation`;
    const response = await Axios.get<AdminTranslationSettingsResponse>(url);
    return response.data;
  };

  return useQuery<AdminTranslationSettingsResponse, AxiosError<BaseError>>(
    [ADMIN_TRANSLATION_QUERY_KEY],
    fetchTranslation,
    {
      useErrorBoundary: false,
      staleTime: 5 * 60 * 1000, // Consider stale after 5 minutes
      retry: 1
    }
  );
};
